import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})

/**
 * Team component
 */
export class TeamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
